import React from 'react'
import "./login.css"
import {Link} from "react-router-dom"

function Login() {
  return (
    <div className='login'>
     
      <div className='login-intro'>
        <h3>Welcome to Daraz! Please login.</h3>
        <p>New member? <Link to="/signup">Register</Link> here.</p>
      </div>
      
      <div className='login-container'>
        <div className='login-form'>
          <label>Phone Number or Email*</label>
          <input type="email" placeholder="Please enter your Phone Number or Email"/>

           <label>Password*</label> 
           <input type="password" placeholder="Please enter your password" />
           <p>Forger Password?</p>
        </div>
        <div className='login--with'>
          <button className='login-btn'>LOGIN</button>
          <p>Or, login with</p>
          <button className='login-fbtn'><strong>f</strong>Facebook</button>
          <button className='login-gbtn'><strong>G+</strong>Google</button>
        </div>
      </div>

       
    </div>
  )
}

export default Login